import { render, staticRenderFns } from "./PartnerDetails.vue?vue&type=template&id=6c7b3da4&scoped=true"
import script from "./PartnerDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerDetails.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PartnerDetails.vue?vue&type=style&index=0&id=6c7b3da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7b3da4",
  null
  
)

export default component.exports